import {
  applyMiddleware,
  compose,
  createStore,
} from 'redux';
import {
  persistStore,
  persistReducer,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import transformImmutable from 'redux-persist-transform-immutable';
import { thunk as reduxThunkMiddleware } from 'redux-thunk';

import {
  ENVIRONMENT__DEVELOPMENT,
} from './constants';
import rootReducer from './rootReducer';

const configureReduxStore = () => {
  try {
    let store;

    const persistedRootReducer = persistReducer(
      {
        key: 'UMWM',
        keyPrefix: 'reduxStore:',
        storage,
        transforms: [transformImmutable()],
      },
      rootReducer,
    );

    if (ENVIRONMENT === ENVIRONMENT__DEVELOPMENT) {
      // eslint-disable-next-line no-underscore-dangle
      const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
      store = createStore(
        persistedRootReducer,
        composeEnhancers(
          applyMiddleware(
            reduxThunkMiddleware,
          ),
        ),
      );
    } else {
      const composeEnhancers = compose;
      store = createStore(
        persistedRootReducer,
        composeEnhancers(
          applyMiddleware(
            reduxThunkMiddleware,
          ),
        ),
      );
    }

    // eslint-disable-next-line prefer-const
    const persistor = persistStore(store, {});

    return {
      instance: store,
      persistor: {
        instance: persistor,
      },
    };
  } catch (exception) {
    return exception;
  }
};

const configuredStore = () => {
  const reduxStore = configureReduxStore();
  const reduxStoreWrapper = {
    store: reduxStore.instance,
    persistor: reduxStore.persistor.instance,
  };

  return reduxStoreWrapper;
};

export default configuredStore();
